import { render } from "./PathwayBadges.vue?vue&type=template&id=197ce4a9&scoped=true&ts=true"
import script from "./PathwayBadges.vue?vue&type=script&lang=ts"
export * from "./PathwayBadges.vue?vue&type=script&lang=ts"

import "./PathwayBadges.vue?vue&type=style&index=0&id=197ce4a9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197ce4a9"]])

export default __exports__